const state = { dark: false }
const getters = { dark: s => s.dark }
const mutations = {
  SET_DARK (s, v) { s.dark = !!v }
}
const actions = {
  initTheme ({ commit }) {
    const saved = localStorage.getItem('prefersDark')
    const system = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
    commit('SET_DARK', saved != null ? saved === 'true' : system)
  },
  toggleDark ({ commit, state }) {
    const next = !state.dark
    commit('SET_DARK', next)
    localStorage.setItem('prefersDark', String(next))
  },
}
export default { namespaced: true, state, getters, mutations, actions }